{
    "dashboard": {
        "title": "Dashboard"
    },
    "expense": {
        "title": "Ausgaben"
    },
    "subscriptions": {
        "title": "Abonnements"
    },
    "credit_card": {
        "title": "Karten"
    },
    "employees": {
        "title": "Mitarbeiter:innen"
    },
    "cost_centers": {
        "title": "Kostenstellen"
    },
    "vendors": {
        "title": "Lieferanten"
    },
    "reporting": {
        "title": "Reporting"
    },
    "settings": {
        "title": "Einstellungen"
    },
    "transactions": {
        "title": "Transaktionen"
    },
    "error": {
        "not_found": {
            "title": "Sorry, diese Seite konnte leider nicht geladen werden.",
            "message": "Die Seite, die Sie geladen haben, konnte leider nicht gefunden werden oder existiert nicht."
        },
        "feature_deactivated": {
            "title": "Sie können auf diese Seite nicht zugreifen, da die Funktion für Ihr Unternehmen deaktiviert wurde.",
            "message": "Wenn Sie Zugriff benötigen, wenden Sie sich bitte an Ihren Administrator."
        },
        "unknown": {
            "title": "Oops!",
            "message": "Ein unbekannter Fehler ist aufgetreten, bitte versuchen Sie es später erneut."
        },
        "button": {
            "return": "Zurück zum Dashboard"
        }
    },
    "kyb": {
        "title": "KYB"
    },
    "liquidity": {
        "title": "Liquiditäts-Management"
    }
}
